import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import { Container } from "../../common/layout/styels";
import { useDispatch, useSelector } from "react-redux";
import { DisplayInformations } from "../../../elements/list/popup";
import { addPageObject } from "../../../../store/actions/pages";
import { useNavigate } from "react-router-dom";
import Loader from "../../../elements/loader";
import CrudForm from "../../../elements/list/create";
import { getData, putData } from "../../../../backend/api";
import ListTable from "../../../elements/list/list";
const PaymentDetails = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  console.log(user);
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "Payment Details",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      upload: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "Surname",
      name: "lastName",
      tab: "Payment Details",
      validation: "textonly",
      default: "",
      label: "Surname",
      required: true,
      upload: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "Company name",
      name: "company",
      validation: "",
      showItem: "organization",
      tab: "Payment Details",
      default: "",
      label: "Company name",
      required: true,
      view: true,
      add: false,
      update: false,
      apiType: "API",
      selectApi: "company/select", // Assume this is the API endpoint to fill the list
    },
    {
        type: "text",
        placeholder: "email",
        name: "email",
        validation: "email",
        default: "",
        tab: "Payment Details",
        label: "email",
        minimum: 5,
        maximum: 40,
        required: true,
        view: true,
      add: true,
      update: true,
      },
      {
        type: "text",
        tab: "Payment Details",
        placeholder: "iban",
        name: "iban",
        validation: "iban",
        default: "",
        label: "iban",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "bic",
        tab: "Payment Details",
        name: "bic",
        validation: "",
        default: "",
        label: "bic",
        maximum: 12,
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "bank",
        tab: "Payment Details",
        name: "bank",
        validation: "textonly",
        default: "",
        label: "bank",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
  ]);
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [updateValues, setUpdateValues] = useState({});
  const [udpateView, setUpdateView] = useState(() => {});
  const [showLoader, setShowLoader] = useState(true);
  const [message, setMessage] = useState();
  const [refreshVal, setRefreshVal] = useState(true);
  //to update the page title
  useEffect(() => {
    document.title = `${t("Payment Details")} - Plan Time`;
  }, [t]);

  let users = useSelector((state) =>
    state.pages[`paymentDetails`]
      ? state.pages[`paymentDetails`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  )

  const [data, setData] = useState(users?.data?.data[0] ?? null)

  useEffect(() => {
    const fetchdata = async ()=>{
      setLoaderBox(true);
      let page = "paymentDetails"
      try {
        dispatch({
          type: "ADD_PAGE_OBJECT_LOADING",
          key: page,
        });
        await getData({skip: 0 }, page, dispatch, navigate)
          .then((response) => {
            dispatch({
              type: "ADD_PAGE_OBJECT",
              payload: { ...response, isLoading: false },
              key: page,
            });
            setData(response?.data?.data[0] ?? null);
            setLoaderBox(false);
            setRefreshVal(false);
          })
          .catch((error) => {
            dispatch({
              type: "ADD_PAGE_OBJECT",
              payload: error,
            });
            setLoaderBox(false);
            setRefreshVal(false);
          });
      } catch (error) {
        dispatch({
          type: "ADD_PAGE_OBJECT",
          payload: error,
        });
        setLoaderBox(false);
        setRefreshVal(false);
      }
    }
    if(refreshVal)
      fetchdata()
  }, [refreshVal])

  const setLoaderBox = (status) => {
    setShowLoader(status);
  };

  
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      {/* {!!data && <DisplayInformations customClass="invoiceData" isEditingHandler={isEditingHandler} setLoaderBox={setLoaderBox} udpateView={udpateView} attributes={attributes} data={data} setMessage={setMessage} tabName="invoiceData"  />}
      {isEditing && <CrudForm delPrivilege={true} deleteHandler={null} setMessage={setMessage} formMode={"single"} formView={"normal"} api="invoiceData" formType={"put"} updateId={updateId} header={t("update", { label: t("invoiceData") })} formInput={attributes} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={isEditingHandler} isOpen={isEditing}></CrudForm>}
      */}
      <ListTable {...props} actions={[]} formMode="double" api={`paymentDetails`} itemTitle={`title`} shortName={`paymentDetails`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes} display={true} dataVal={data} setRefreshVal={setRefreshVal} ></ListTable>
      {showLoader && <Loader></Loader>} 
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(PaymentDetails);
